var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #d6002e;\n        stroke-miterlimit: 10;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 24,
    height: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.4846,8.5817h-3.7803c-.9844,0-1.7824.798-1.7824,1.7824v7.5868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.9364,9.2136c.327-.3865.8155-.6319,1.3615-.6319h3.7803v9.3692"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.6367,17.9509v-8.9008c0-1.1549.798-2.0911,1.7824-2.0911h5.0943v10.9919"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 4.7032,
    cy: 5.1838,
    r: 1.7752
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 12.0751,
    cy: 3.132,
    r: 1.7752
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 19.5072,
    cy: 5.1838,
    r: 1.7752
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3.3833,
    y1: 17.9509,
    x2: 3.3833,
    y2: 22.8057
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.0231,
    y1: 17.9509,
    x2: 6.0231,
    y2: 22.8057
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 10.7552,
    y1: 17.9509,
    x2: 10.7552,
    y2: 22.8057
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 13.395,
    y1: 17.9509,
    x2: 13.395,
    y2: 22.8057
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 18.1874,
    y1: 17.9509,
    x2: 18.1874,
    y2: 22.8057
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 20.8271,
    y1: 17.9509,
    x2: 20.8271,
    y2: 22.8057
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.22a52046.svg";
export { ForwardRef as ReactComponent };